import { Link } from "react-router-dom";
import { usePatientMode } from "@/lib/patientMode";
import { EXO_DRIVERS } from "@/data/driversExo";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const STORAGE_KEY = "m2hat_drivers_exo_progress";
export const ENTOURAGE_KEY = "m2hat_drivers_entourage_token";
export const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
export const DRIVER_BY_KEY = Object.fromEntries(EXO_DRIVERS.map((d) => [d.key, d]));
export const DRIVER_IMAGE = (key) => `/drivers/${key}.jpg`;
export const DEFAULT_RANKING = EXO_DRIVERS.map((d) => d.key);

export const ENTOURAGE_CASES = [
  { key: "utile", label: "situations où ce driver lui a été utile" },
  { key: "pas_utile", label: "situations où ce driver ne lui a pas été utile" },
  { key: "aurait_utile", label: "situations où ce driver lui aurait été utile" },
];
export const DRIVER_CASE_MINE = {
  utile: "ce driver m'a été utile",
  pas_utile: "ce driver ne m'a pas été utile",
  aurait_utile: "ce driver m'aurait été utile",
};

export const HomeLink = () => {
  const { patientMode } = usePatientMode();
  if (patientMode) return null;
  return (
    <Link to="/" data-testid="exo-home-link" className="inline-block mb-6 text-sm text-[var(--ink-soft)] hover:text-[var(--gold)] transition-colors no-print">
      ← Tous les modules
    </Link>
  );
};

export const BulletBlock = ({ title, items, color }) => (
  <div className="print-break">
    <p className="text-xs font-semibold uppercase tracking-[0.12em] mb-1" style={{ color }}>{title}</p>
    <ul className="list-disc pl-5 space-y-0.5 text-sm text-[var(--ink)]">
      {items.map((it) => (<li key={it}>{it}</li>))}
    </ul>
  </div>
);
